module.exports={
  personal_details:{
    address_l1:"B170 103 Shapoorji Pallonji,Kolkata, West Bengal, 700135",
    address_l2:"Kolkata, West Bengal, 700135",
    phone:"+91-9630508256",
    email:"shivanikndm@gmail.com"
  },

  about_l1:"I'm an experienced full stack developer. I enjoy coding and love to convert into real life products.",
};